import React from "react";
import PlatformLayout from "../../components/platform/PlatformLayout";
import { PlatformZones } from "../../components/platform/PlatformZones";

const Pricing: React.FC = () => {

 return (
  <PlatformLayout>
   {/* Dynamically render zones based on stored order */}
   <PlatformZones pageSlug="pricing" />
  </PlatformLayout>
 );
};

export default Pricing;

